export const property = {
  createProperty: {
    title: "Créer une propriété",
    of: "sur",
  },
  sections: {
    details: "Détails de la propriété",
    presentation: "Présentation",
    rooms: "Chambres",
    bookingSettings: "Paramètres de réservation",
    checkinSettings: "Paramètres de check-in",
    extras: "Services supplémentaires",
  },

  menu: {
    name: "Nom",
    location: "Emplacement",
    logo: "Logo de la propriété",
    capacity: "Capacité",
    services: "Services de la propriété",
    description: "Description",

    roomTypes: "Types de chambre",
    roomManagement: "Gérer les chambres",

    imagesRooms: "Images des chambres",
    imagesProperty: "Images de la propriété",

    priceCurrency: "Prix et devise",
    rates: "Tarifs",
    maintenance: "Maintenance de la propriété",

    scheduling: "Planification",

    sesHospedajes: "SES Hébergements",

    smartLocks: "Serrures connectées",
    experiences: "Expériences et services",
    chatbot: "ChatBot IA",
  },

  firstStep: {
    heading: "Quel est le nom de votre hébergement ?",
    subheading:
      "Attirez les clients avec un nom accrocheur qui met en valeur le meilleur de votre établissement.",
    fieldLabel: "Le nom de votre hébergement",
    placeholder: "p. ex. Plage Paradis",
    internalNameLabel: "Nom interne",
    internalNamePlaceholder: "Nom de référence interne pour l'hébergement",
  },

  locationStep: {
    heading: "Où se situe votre hébergement ?",
    subheading:
      "Indiquez l'adresse exacte pour que les clients trouvent facilement votre établissement.",
    countryLabel: "Pays",
    addressLabel: "Adresse complète",
    addressPlaceholder: "p. ex. 25 rue Sierpes, Séville",
    cityLabel: "Ville",
    cityPlaceholder: "p. ex. Séville",
    zipLabel: "Code postal",
    zipPlaceholder: "p. ex. 41004",
  },
  logoStep: {
    heading: "Quel est le logo de votre hébergement ?",
    description:
      "Ajoutez le logo de votre hébergement pour paraître plus professionnel et être plus facilement identifiable. Formats autorisés : PNG, JPG, SVG.",
    currentLogoTitle: "Logo actuel :",
    currentLogoAlt: "Logo actuel",
  },

  roomTypeStep: {
    heading: "Informations sur la chambre",
    description:
      "Saisissez un nom pour ce type de chambre, comme “Chambre Double” ou “Suite Familiale”. Cela vous aidera à l'identifier facilement dans le calendrier et les canaux de réservation. Depuis votre tableau de bord, vous pourrez ajouter vos autres types de chambre",
    basicInfoTitle: "Informations de base",
    nameLabel: "Nom",
    namePlaceholder: "Nom personnalisé",
    occupancyTitle: "Capacité de la chambre",
    adultsLabel: "Adultes",
    childrenLabel: "Enfants",
    infantsLabel: "Bébés",
  },

  hotelRoomsStep: {
    heading: "Attribuez les chambres physiques de votre propriété",
    description:
      "Créez les chambres réelles qui seront disponibles à la réservation, comme “101 - Chambre Double” ou “302 - Suite Familiale”. Cela vous aidera à les organiser sur le calendrier et à gérer la disponibilité en toute simplicité.",
    roomTypeLabel: "Type de chambre",
    roomNameLabel: "Nom de la chambre",
    roomNamePlaceholder: "Nom personnalisé",
    roomCodeLabel: "Numéro ou code de chambre",
    roomCodePlaceholder: "Facultatif",
  },

  capacityStep: {
    heading: "Partagez les informations essentielles sur votre établissement",
    description:
      "Indiquez le nombre de personnes, de chambres et de salles de bain. Notez que les chambres et les salles de bain sont considérées comme privées par défaut. Si elles sont partagées, vous pourrez le modifier ultérieurement dans les détails de votre propriété.",
    labels: {
      guests: "Personnes",
      bedrooms: "Chambres",
      bathrooms: "Salles de bain",
    },
  },

  servicesStep: {
    heading: "Montrez aux clients ce que propose votre établissement",
    subtitle:
      "Sélectionnez les équipements disponibles. Vous pourrez en ajouter d'autres plus tard depuis le CMS.",
    services: {
      oven: "Four et plaques de cuisson",
      pets_allowed: "Animaux acceptés",
      wifi: "Internet Wi-Fi",
      essentials: "Équipements essentiels",
      washing_machine: "Machine à laver",
      air_conditioning: "Climatisation",
      heating: "Chauffage central",
      parking: "Place de parking",
      children_allowed: "Enfants acceptés",
      refrigerator: "Réfrigérateur",
    },
  },

  priceStep: {
    heading: "Quel est le prix par nuit ?",
    subtitle:
      "Définissez le prix par défaut pour créer le premier tarif par nuit, ainsi que la devise de votre propriété.",
    labels: {
      pricePerNight: "Tarif par nuit",
      currency: "Devise",
    },
    placeholders: {
      priceExample: "p. ex. 100",
    },
    requiredAsterisk: "*",
  },

  descriptionStep: {
    heading: "Comment décririez-vous votre établissement ?",
    subtitle:
      "Attirez les clients avec une brève description de votre propriété. Mettez en avant les équipements disponibles et les points d'intérêt à proximité.",
    placeholders: {
      example:
        "p. ex. Un loft élégant avec vue sur la ville — parfait pour travailler, faire du shopping et s'imprégner de l'ambiance urbaine.",
    },
    inspiration: "Besoin d'inspiration ?",
    buttons: {
      useAI: "Utiliser l'IA",
      generating: "Génération...",
    },
    errors: {
      generate:
        "Une erreur s'est produite lors de la génération de la description. Veuillez réessayer.",
    },
  },
  navigation: {
    save: "Enregistrer",
    next: "Suivant",
  },
  common: {
    success: "Succès",
    error: "Erreur",
    cancel: "Annuler",
    save: "Enregistrer",
  },

  images: {
    heading: "Images de la propriété",
    subtitleHotel:
      "Ajoutez les photos de vos chambres pour qu'elles puissent être utilisées sur votre page de réservation directe.",
    subtitleApt:
      "Ajoutez les photos de votre propriété pour qu'elles puissent être utilisées sur votre page de réservation directe.",

    loadRoomsError: "Impossible de charger les chambres",
    uploadSuccess: "Images valides téléchargées avec succès",
    uploadErrorGeneric: "Erreur lors du téléchargement des images",

    deleteConfirmMessage: "Êtes-vous sûr de vouloir supprimer cette image ?",
    deleteConfirmHeader: "Confirmation",
    deleteAccept: "Supprimer",
    deleteReject: "Annuler",
    deleteSuccess: "Image supprimée avec succès",
    deleteError: "Erreur lors de la suppression de l'image",

    setMainSuccess: "Image principale mise à jour",
    setMainError: "Erreur lors de la définition de l'image principale",

    invalidFilesTitle: "Fichiers non valides",

    mainBadge: "Principale",
  },

  dropzone: {
    prompt: "Glissez les images ici ou cliquez pour sélectionner",
    formatHint: "Formats : JPEG, PNG, GIF.",
    uploading: "Téléchargement des images... {progress}%",
    invalidHeader: "Certains fichiers ne répondent pas aux exigences :",
    reasonType: "type non valide",
    reasonSize: "dépasse la limite de taille",
    and: "et",
  },

  checkin: {
    heading: "Quand les liens de check-in seront-ils envoyés ?",
    subtitle:
      "Planifiez l'envoi automatique du lien de check-in à vos clients.",

    options: {
      same_day: { amount: "Le jour même", text: "du check-in" },
      24: { amount: "24 heures", text: "avant le check-in" },
      48: { amount: "48 heures", text: "avant le check-in" },
      72: { amount: "72 heures", text: "avant le check-in" },
      disabled: { amount: "Désactiver", text: "Je l'enverrai manuellement" },
    },
    recommended: "Recommandé",

    details: {
      sameDay: "6 h le jour même",
      previousNight: "18 h la veille au soir",
      corresponding: "18 h le jour correspondant",
    },

    confirm: {
      message: "Êtes-vous sûr de vouloir modifier la planification du check-in ?",
      header: "Confirmer la modification",
      accept: "Modifier la planification",
      reject: "Annuler",
    },

    toasts: {
      loadError: {
        title: "Erreur",
        body: "Échec du chargement des paramètres de check-in.",
      },
      saveSuccess: {
        title: "Paramètres mis à jour",
        body: "Processus terminé avec succès",
      },
    },

    messages: {
      disabled: "L'envoi automatique est désactivé. Il doit être envoyé manuellement.",
      same_day: "Les check-ins seront envoyés à 6 h le jour même du check-in",
      exactly24: "Les check-ins seront envoyés à 18 h la veille du check-in",
      // If you don't have ICU plural, use a generic message
      daysBefore:
        "Les check-ins seront envoyés à 18 h, {days} jour(s) avant le check-in",
    },
  },

  police: {
    header: "Enregistrer les coordonnées de l'autorité compétente",
    toasts: {
      saveSuccess: {
        title: "Action réalisée avec succès",
        body: "Les données de l'autorité ont été enregistrées avec succès",
      },
    },
    errors: {
      lessorRequired: {
        title: "Erreur, champ bailleur",
        body: "Le code bailleur est obligatoire",
      },
      establishmentRequired: {
        title: "Erreur, champ établissement",
        body: "Le code établissement est obligatoire",
      },
    },
  },

  identity: {
    title: "Boutique du check-in",
    subtitle: "Au check-in, le voyageur reçoit par WhatsApp un lien avec ce qu'il peut ajouter à son séjour.",
    propertyLabel: "Propriété :",
    toggle: {
      title: "Activer la vérification d'identité",
      hint: "Lorsqu'elle est activée, les clients devront vérifier leur identité.",
      on: "ON",
      off: "OFF",
    },
    config: {
      whatTitle: "Que demandez-vous au voyageur ?",
      whatHint:
        "Choisissez les photos qu'il devra prendre. Au moins une.",
      frontTitle: "Document recto",
      frontDesc:
        "Le côté avec la photo. C'est celui que l'on compare au selfie.",
      backTitle: "Document verso",
      backDesc:
        "Le verso, où figurent en général l'adresse et la zone de lecture.",
      selfieTitle: "Selfie sur le moment",
      selfieDesc:
        "Une photo de son visage, prise sur le vif avec la caméra.",
      compareOn: "Le visage du document est comparé au selfie.",
      compareOff:
        "La photo est seulement conservée : sans document ni selfie, il n'y a pas de visages à comparer.",
      requiredTitle: "Et si les visages ne correspondent pas…",
      noTitle: "Il peut continuer",
      noDesc:
        "Il termine l'enregistrement quand même et vous le voyez signalé dans le panneau.",
      yesTitle: "Il ne peut pas continuer",
      yesDesc:
        "Il ne pourra pas terminer l'enregistrement tant que cela n'aura pas abouti. Il peut réessayer autant de fois qu'il le faut.",
      lockedHint: "Pour l'exiger, il faut le document recto et le selfie.",
      summaryTitle: "Le voyageur verra",
      needOne: "Vous devez demander au moins une photo.",
      noStorage:
        "Dans ce pays, nous ne conservons pas les photos d'identité, seulement le résultat. Sans comparaison faciale, il ne restera aucune trace.",
      serviceDown:
        "Si notre service de comparaison tombe en panne, le voyageur peut continuer et vous le voyez signalé : personne ne reste à la porte à cause d'une panne de notre côté.",
    },
    toasts: {
      updated: "Paramètres de vérification d'identité mis à jour avec succès",
      updateError: "Erreur lors de la mise à jour des paramètres de vérification d'identité",
    },
  },

  guestReviews: {
    subtitle:
      "Saisissez l'URL du site d'avis que vous souhaitez configurer afin que vos clients puissent laisser leur avis, que ce soit sur Google ou un autre site d'avis que vous utilisez. Cela contribue à améliorer la visibilité et la réputation de l'hébergement.",
    enableTitle: "Activer les avis des clients",
  },

  smartLocks: {
    title: "Serrures connectées",
    subtitle:
      "Connectez-vous à des serrures connectées compatibles et oubliez les clés physiques. Générez et envoyez des codes d'accès automatiquement — sans travail manuel, 100 % sécurisé.",
    propertyLabel: "Propriété",
    compatibleTitle: "Serrures connectées compatibles",
    andManyMore: "et bien d'autres...",

    enableTitle: "Activer la serrure connectée",
    enableHelp:
      "Envoyez le code d'accès à vos clients une fois le check-in terminé, précisément à l'heure de check-in sélectionnée.",

    configTitle: "Configuration",
    configSubtitle: "Définissez vos préférences d'envoi du code d'accès",

    deliveryLabel: "Heure d'envoi du code d'accès",
    deliveryDesc:
      "Choisissez l'heure à laquelle le code d'accès sera envoyé à votre client le jour de sa réservation.",
    saveTimeBtn: "Enregistrer l'heure",
    saveTimeLoading: "Enregistrement...",

    accessTypeLabel: "Type de code d'accès",

    static: {
      title: "Code statique",
      desc: "Utiliser le même code pour tous les clients",
    },
    dynamic: {
      title: "Code dynamique",
      desc: "Générer des codes uniques par réservation",
      soon: "Bientôt disponible",
    },

    masterCodeLabel: "Code d'accès principal",
    masterCodePlaceholder: "Saisissez votre code d'accès principal",
    saveCodeBtn: "Enregistrer le code",
    saveCodeLoading: "Enregistrement...",

    masterCodeHelp:
      "Ce code sera envoyé automatiquement aux clients à l'heure spécifiée le jour de leur check-in.",

    dynamicInfo: {
      title: "Codes d'accès dynamiques",
      desc: "Cette fonctionnalité premium générera automatiquement des codes d'accès uniques pour chaque réservation, offrant une sécurité renforcée et une meilleure expérience client. Bientôt disponible !",
    },

    support: {
      title: "Besoin d'aide pour l'intégration ?",
      desc: "Nous nous intégrons à toutes les grandes marques de serrures connectées. Notre équipe technique vous aidera à configurer votre modèle spécifique.",
      cta: "Contacter le support",
    },

    errors: {
      emptyKey: "Veuillez saisir une clé d'accès",
    },

    toasts: {
      updateSuccess: "Paramètres de la serrure connectée mis à jour avec succès",
      updateError: "Erreur lors de la mise à jour des paramètres de la serrure connectée",
      timeSuccess: "Heure d'envoi mise à jour avec succès",
      timeError: "Erreur lors de la mise à jour de l'heure d'envoi",
      keySuccess: "Clé d'accès enregistrée avec succès",
      keyError: "Erreur lors de l'enregistrement de la clé d'accès",
    },
  },

  services: {
    listMovedHelp: "La liste de services est unique pour tout le compte : écrivez-la une fois et cochez dans quelles annonces elle est proposée.",
    listMovedLink: "Aller à Services et expériences",
    title: "Expériences et services",
    subtitle: "Gérez les services supplémentaires de votre propriété.",
    enableTitle: "Activer la boutique d'expériences et de services",
    enableHelp:
      "Faites la promotion de toutes les expériences et de tous les services supplémentaires de votre propriété. Les clients reçoivent un lien WhatsApp lors du check-in.",
    storeType: {
      title: "Type de boutique",
      internal: {
        title: "Boutique interne",
        desc: "Gérez vos services directement sur la plateforme",
      },
      external: {
        title: "Boutique externe",
        desc: "Redirigez les clients vers votre boutique externe",
      },
    },
    externalConfig: {
      title: "Configuration de la boutique externe",
      guestMessageLabel: "Message pour les clients",
      guestMessagePlaceholder:
        "Ex. : Découvrez nos services supplémentaires et nos expériences uniques dans notre boutique en ligne...",
      guestMessageHelp:
        "Message affiché aux clients après le check-in (max. 200 caractères)",
      urlLabel: "L'URL de votre boutique externe",
      urlPlaceholder: "https://your-external-store.com",
      urlHelp: "URL complète où les clients peuvent réserver des expériences et des services",
      noteTitle: "Remarque :",
      noteText:
        "Les clients recevront ce message personnalisé avec le lien après avoir terminé le check-in.",
    },
    addBtn: "Ajouter",
    delete: {
      title: "Supprimer le service ?",
      text: "Cette action est irréversible",
      confirm: "Supprimer",
      cancel: "Annuler",
    },
    toasts: {
      stateUpdated: "État du service mis à jour",
      deleted: "Service supprimé avec succès",
      storeUpdated: "Paramètres des expériences et services mis à jour avec succès",
      storeError: "Erreur lors de la mise à jour des paramètres des expériences et services",
      configUpdated: "Configuration de la boutique mise à jour avec succès",
      configError: "Erreur lors de la mise à jour de la configuration de la boutique",
    },
  },
  bot: {
    enableTitle: "Activer l'assistant virtuel",
    enableHelp: "Automatisez l'assistance aux clients avec des réponses rapides sur WhatsApp.",
  },

  rooms: {
    heading: "Types de chambre",
    subtitle: "Gérez les types de chambre de votre propriété.",
    addTypeCta: "Ajouter un type de chambre",
    adultsCapacity: "Capacité adultes : {count}",
    emptyList: "Aucune chambre enregistrée.",

    deleteConfirmHeader: "Confirmer la suppression",
    deleteConfirmMessage:
      "Êtes-vous sûr de vouloir supprimer cette chambre ? Cette action est irréversible.",
    deleteConfirmAccept: "Oui, supprimer",
    deleteConfirmReject: "Annuler",

    deleteSuccess: "Chambre supprimée avec succès.",
    deleteError: "Erreur lors de la suppression de la chambre.",
  },

  roomMgmt: {
    remaining: "Disponibles : {count}",
    heading: "Gérer les chambres",
    subtitle: "Attribuez des chambres individuelles aux types enregistrés.",
    totalRooms: "Total des chambres : {count}",

    typeLabel: "Type",
    codeLabel: "Code",
    nameLabel: "Nom",
    descLabel: "Description",

    selectPlaceholder: "Sélectionner",
    codePlaceholder: "Code",
    namePlaceholder: "Nom de la chambre",
    descPlaceholder: "Description de la chambre",

    addBtn: "Ajouter",

    planLimitTitle: "Limite atteinte",
    planLimitMsg:
      "Vous avez atteint le nombre maximal de chambres autorisé par votre forfait. Veuillez faire évoluer votre abonnement pour en ajouter davantage.",

    loadTypesError: "Impossible de charger les types de chambre",
    loadRoomsError: "Impossible de charger les chambres existantes",

    saveSuccessTitle: "Succès",
    saveSuccessMsg: "Chambres enregistrées avec succès",
    saveError: "Impossible d'enregistrer les chambres",

    deleteSuccess: "Chambre supprimée avec succès.",
    deleteError: "Erreur lors de la suppression de la chambre.",
    formIncompleteError:
      "Veuillez renseigner le type et le nom de chambre pour toutes les chambres.",
  },

  rates: {
    heading: "Tarifs",
    subtitleHotel: "Gérez les tarifs de vos hébergements.",
    subtitleSingle: "Gérez les tarifs de votre hébergement.",
    adultsCapacity: "Capacité adultes : {count}",
    roomsCount: "Chambres {count}",
    singleUnit: "Unité d'hébergement",

    table: {
      name: "Nom",
      occupancy: "Personnes",
      priceTaxIncl: "Prix (TAXES INCLUSES)",
      actions: "Actions",
    },

    addRate: "Ajouter un tarif",
    emptyList: "Aucun tarif enregistré.",

    deleteConfirmHeader: "Confirmer la suppression",
    deleteConfirmMessage:
      "Êtes-vous sûr de vouloir supprimer ce tarif ? Cette action est irréversible.",
    deleteConfirmAccept: "Oui, supprimer",
    deleteConfirmReject: "Annuler",

    deleteSuccess: "Tarif supprimé avec succès.",
    deleteError: "Erreur lors de la suppression du tarif.",
  },
};

export default property;
